import { Injectable } from '@angular/core';
import { MiaHttpService, ApiResponse } from '@mobileia/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SectionService extends MiaHttpService {

  constructor(
    private http: HttpClient
  ) {
    super(http);
  }

  contactHelp(name: string, email: string, message: string): Observable<ApiResponse<any>> {
    return this.postObject(environment.baseUrl + 'section/contact-help', { nane: name, email: email, message: message });
  }

  fetchProductFeatureBox(): Observable<ApiResponse<any>> {
    return this.fetchBySlug('home-product-box');
  }

  fetchTwoProductFeature(): Observable<ApiResponse<any>> {
    return this.fetchBySlug('home-two-product');
  }

  fetchBannerSearch(): Observable<ApiResponse<any>> {
    return this.fetchBySlug('banner-search');
  }

  fetchTerms(): Observable<ApiResponse<any>> {
    return this.fetchBySlug('terms');
  }

  fetchBySlug(slug: string): Observable<ApiResponse<any>> {
    return this.postObject(environment.baseUrl + 'section/fetch-by-slug', { slug: slug });
  }

  fetchHelpSection(): Observable<ApiResponse<any>> {
    return this.postObject(environment.baseUrl + 'section/fetch-helpbox', { });
  }

  subscribeNewsletter(email: string): Observable<ApiResponse<any>> {
    return this.postObject(environment.baseUrl + 'newsletter/subscribe', {
      email: email,
      firstname: '',
      lastname: '',
      phone: ''
    });
  }
}
